import { HeaderTarifsWrapper } from "./HeaderTarifs.style";
import Link from "next/link";

export default function HeaderTarifs() {
  return (
    <HeaderTarifsWrapper>
      <div className="bande_bleu">
        <h1 className="faites">
          Faites décoller votre patrimoine avec nos offres
        </h1>
        <h2 className="suivre">
          Suivre, analyser et décider librement
          <br />
          <br />
          <i>
            Notre outil est actuellement en bêta test auprès de nos clients, il
            n'est pas possible de souscrire à notre abonnement cependant vous
            pouvez{" "}
            <Link href="/start">
              <strong>prendre un rendez-vous visio</strong>
            </Link>{" "}
            pour réussir vos projets
          </i>
        </h2>
      </div>
    </HeaderTarifsWrapper>
  );
}
